import { Link as RouterLink, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

function BreadcrumbNav({
  listingPath: _listingPath = "/admin/incomplete-queries",
  listingLabel: _listingLabel = "Quotes",
  currentLabel,
  quoteId,
}) {
  const { pathname } = useLocation();
  const seg = pathname.split("/").filter(Boolean);
  const isHex24 = (s) => /^[a-f0-9]{24}$/i.test(s);
  const title = (s) =>
    (s || "")
      .split("-")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

  let crumbs = [];
  let id = quoteId || null;
  let afterId = null;

  if (seg[0] === "admin" || seg[0] === "operator" || seg[0] === "user") {
    const role = seg[0];
    const s1 = seg[1];

    if (seg[1] === "newQuotePage") {
      id = id || seg[2] || null;
      afterId = seg.slice(3);
      if (id) {
        crumbs.push({ label: `#QUOTE${id}`, to: `/${role}/newQuotePage/${id}` });
        if (afterId && afterId.length) {
          const label = currentLabel || title(afterId[0]);
          crumbs.push({ label, to: undefined });
        }
      }
    } else if (isHex24(seg[1])) {
      id = id || seg[1];
      afterId = seg.slice(2);
      if (id) {
        crumbs.push({ label: `#QUOTE${id}`, to: `/${role}/newQuotePage/${id}` });
        if (afterId && afterId.length) {
          const label = currentLabel || title(afterId[0]);
          crumbs.push({ label, to: undefined });
        }
      }
    } else {
      const tail = seg.slice(2);
      if (tail.length > 0) {
        let pathAcc = `/${role}/${s1 || ""}`;
        tail.forEach((part, idx) => {
          pathAcc += `/${part}`;
          const isLast = idx === tail.length - 1;
          crumbs.push({
            label: isLast && currentLabel ? currentLabel : title(part),
            to: isLast ? undefined : pathAcc,
          });
        });
      } else if (currentLabel) {
        crumbs.push({ label: currentLabel, to: undefined });
      }
    }
  }

  if (crumbs.length === 0) return null;

  const pillBase =
    "inline-flex max-w-full min-w-0 items-center gap-1 rounded-full border px-2.5 py-1 text-[11px] font-semibold tracking-tight transition-colors";

  return (
    <nav aria-label="breadcrumb" className="w-full max-w-full">
      <div className="flex min-w-0 flex-wrap items-center gap-1.5">
        {crumbs.map((c, idx) => {
          const isLast = idx === crumbs.length - 1;
          const key = `${c.label}-${idx}`;
          return (
            <span key={key} className="flex min-w-0 items-center gap-1.5">
              {idx > 0 ? (
                <ChevronRight className="h-3 w-3 shrink-0 text-slate-300 dark:text-slate-600" aria-hidden />
              ) : null}
              {c.to && !isLast ? (
                <RouterLink
                  to={c.to}
                  className={`${pillBase} border-slate-200/90 bg-white/90 text-slate-600 shadow-sm hover:border-fk-accent/30 hover:bg-sky-50/90 hover:text-slate-900 dark:border-slate-600/70 dark:bg-slate-800/90 dark:text-slate-300 dark:hover:border-fk-accent/40 dark:hover:bg-slate-800 dark:hover:text-white`}
                >
                  {idx === 0 ? (
                    <Home className="h-3 w-3 shrink-0 text-fk-accent opacity-90" aria-hidden />
                  ) : null}
                  <span className="truncate">{c.label}</span>
                </RouterLink>
              ) : (
                <span
                  className={`${pillBase} ${
                    isLast
                      ? "border-fk-accent/25 bg-gradient-to-r from-sky-50 to-white text-slate-900 shadow-[0_1px_8px_rgba(14,165,233,0.12)] dark:border-blue-500/25 dark:from-slate-800 dark:to-slate-900 dark:text-white"
                      : "border-slate-200/90 bg-slate-50/95 text-slate-700 dark:border-slate-600/70 dark:bg-slate-800/80 dark:text-slate-200"
                  }`}
                  aria-current={isLast ? "page" : undefined}
                >
                  {idx === 0 && !c.to ? (
                    <Home className="h-3 w-3 shrink-0 text-fk-accent opacity-90" aria-hidden />
                  ) : null}
                  <span className="truncate">{c.label}</span>
                </span>
              )}
            </span>
          );
        })}
      </div>
    </nav>
  );
}

export default BreadcrumbNav;
